import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import lang from 'lang'
import { replace } from 'common/utils'

import NudgeAssignment from './assignment'

export default class AssignmentNudgeSet extends React.Component {
  static propTypes = {
    index: PropTypes.number,
    nudgeSet: PropTypes.object.isRequired,
    nudgeType: PropTypes.object.isRequired,
    disableStats: PropTypes.bool,
    stats: PropTypes.object,
  }

  static defaultProps = {
    disableStats: true,
  }

  constructor(props) {
    super(props)
    // Only the first item should be open by default
    this.state = { active: this.props.index === 0 || false }
  }

  get tasksLeft() {
    const { stats } = this.props
    return stats.total_persons * stats.total_nudges - stats.total_completed
  }

  toggleTab() {
    this.setState((prevState) => ({ active: !prevState.active }))
  }

  renderStats() {
    const { disableStats, stats } = this.props
    if (disableStats || _.isEmpty(stats)) return null

    if (stats.completed_nudge_set) {
      return lang.dashboard.nudges.everybodyCompleted
    }

    const { tasksLeft } = this
    if (_.isNumber(tasksLeft)) {
      if (tasksLeft === 1) {
        return lang.dashboard.nudges.oneTaskToCompleteInSchool
      }
      return replace(lang.dashboard.nudges.tasksToCompleteInSchool, [tasksLeft])
    }
  }

  render() {
    const { nudgeSet, nudgeType, stats } = this.props

    return (
      <li className={cn('accordion-item', { 'is-active': this.state.active })}>
        <a
          onClick={() => this.toggleTab()}
          onKeyDown={() => this.toggleTab()}
          tabIndex="0"
          className="accordion-title"
          aria-controls="accordion"
          role="tab"
          aria-expanded="true"
          aria-selected="true">
          <h3 className="nudges-group-title">
            <span>{`${nudgeType.name} ${nudgeSet.index.toString().padStart(2, '0')}`}</span>
            <div>{nudgeSet.guide_title ? nudgeSet.guide_title : nudgeSet.title}</div>
          </h3>
          <p className={cn('nudges-counter', { done: stats && stats.completed_nudge_set })}>
            {this.renderStats()}
          </p>
          <p
            className="nudges-desc"
            dangerouslySetInnerHTML={{
              __html: nudgeSet.guide_description
                ? nudgeSet.guide_description
                : nudgeSet.description,
            }}
          />
        </a>
        <div
          className="accordion-content"
          role="tabpanel"
          aria-labelledby="accordion-label"
          aria-hidden="false"
          style={{
            display: this.state.active ? 'block' : 'none',
          }}>
          <ul className="nudges-task-list">
            <NudgeAssignment nudgeSet={nudgeSet} />
          </ul>
        </div>
      </li>
    )
  }
}
